
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateRequest} from './ConfigUpdateRequest';
import {FieldModelConfigUpdateRequest} from './ConfigUpdateRequest';
import {SymbolSwapSettingsImportResponse} from './SymbolSwapSettingsImportResponse';
import {SwapSettings} from '../core/SwapSettings';
import {FieldModelSwapSettings} from '../core/SwapSettings';

/**
 * SymbolSwapSettingsImportRequest struct
 */
class SymbolSwapSettingsImportRequest extends ConfigUpdateRequest {
  /**
   * Initialize struct
   * @param {!ConfigUpdateRequest=} parent
   * @param {!Map=} swapSettings
   * @constructor
   */
  constructor (parent = new ConfigUpdateRequest(), swapSettings = new Map()) {
    super()
    super.copy(parent)
    this.SwapSettings = swapSettings
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolSwapSettingsImportRequest}
   * @param {!SymbolSwapSettingsImportRequest} other Other struct
   * @returns {!SymbolSwapSettingsImportRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SwapSettings != null) {
      this.SwapSettings = new Map()
      Object.keys(other.SwapSettings).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = key
          if (other.SwapSettings[key] != null) {
            let tempValue
            tempValue = SwapSettings.fromObject(other.SwapSettings[key])
            this.SwapSettings.set(tempKey, tempValue)
          } else {
            this.SwapSettings.set(tempKey, null)
          }
        }
      })
    } else {
      this.SwapSettings = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolSwapSettingsImportRequest}
   * @returns {!SymbolSwapSettingsImportRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolSwapSettingsImportRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolSwapSettingsImportRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolSwapSettingsImportRequest}
   * @param {!SymbolSwapSettingsImportRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolSwapSettingsImportRequest)) {
      throw new TypeError('Instance of SymbolSwapSettingsImportRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolSwapSettingsImportRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SwapSettings: ((this.SwapSettings != null) ? fbe.MapToObject(new Map(Array.from(this.SwapSettings, item => [((item[0] != null) ? item[0] : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolSwapSettingsImportRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolSwapSettingsImportRequest} other Object value
   * @returns {!SymbolSwapSettingsImportRequest} Created struct
   */
  static fromObject (other) {
    return new SymbolSwapSettingsImportRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolSwapSettingsImportRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolSwapSettingsImportRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolSwapSettingsImportRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6637
  }
}

export { SymbolSwapSettingsImportRequest };

/**
 * Fast Binary Encoding SymbolSwapSettingsImportRequest field model
 */
class FieldModelSymbolSwapSettingsImportRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateRequest(buffer, 4 + 4)
    this.SwapSettings = new fbe.FieldModelMap(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), new FieldModelSwapSettings(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the ConfigUpdateRequest field model
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @returns {!FieldModelConfigUpdateRequest} ConfigUpdateRequest field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SwapSettings.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SwapSettings.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolSwapSettingsImportRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6637
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SwapSettings.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SwapSettings.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SwapSettings.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @param {!SymbolSwapSettingsImportRequest} fbeValue Default value, defaults is new SymbolSwapSettingsImportRequest()
   * @returns {!SymbolSwapSettingsImportRequest} SymbolSwapSettingsImportRequest value
   */
  get (fbeValue = new SymbolSwapSettingsImportRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @param {!SymbolSwapSettingsImportRequest} fbeValue SymbolSwapSettingsImportRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SwapSettings.fbeSize) <= fbeStructSize) {
      this.SwapSettings.get(fbeValue.SwapSettings)
    } else {
      fbeValue.SwapSettings.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SwapSettings.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @param {!SymbolSwapSettingsImportRequest} fbeValue SymbolSwapSettingsImportRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolSwapSettingsImportRequest}
   * @param {SymbolSwapSettingsImportRequest} fbeValue SymbolSwapSettingsImportRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SwapSettings.set(fbeValue.SwapSettings)
  }
}

export { FieldModelSymbolSwapSettingsImportRequest };

/**
 * Fast Binary Encoding SymbolSwapSettingsImportRequest model
 */
class SymbolSwapSettingsImportRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolSwapSettingsImportRequest(this.buffer, 4)
  }

  /**
   * Get the SymbolSwapSettingsImportRequest model
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @returns {!FieldModelSymbolSwapSettingsImportRequest} model SymbolSwapSettingsImportRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolSwapSettingsImportRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolSwapSettingsImportRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @param {!SymbolSwapSettingsImportRequest} value SymbolSwapSettingsImportRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @param {!SymbolSwapSettingsImportRequest} value SymbolSwapSettingsImportRequest value, defaults is new SymbolSwapSettingsImportRequest()
   * @return {!object} Deserialized SymbolSwapSettingsImportRequest value and its size
   */
  deserialize (value = new SymbolSwapSettingsImportRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolSwapSettingsImportRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolSwapSettingsImportRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolSwapSettingsImportRequestModel}
   * @param {!number} prev Previous SymbolSwapSettingsImportRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolSwapSettingsImportRequestModel };
SymbolSwapSettingsImportRequest.__has_response = true;
SymbolSwapSettingsImportRequest.__response_class = SymbolSwapSettingsImportResponse;
